import * as React from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export default function ErrorPopover({ anchorEl, setAnchorEl, firstError }) {

    const errorsOpen = Boolean(anchorEl);

    const handleErrorsClose = () => {
        setAnchorEl(null);
    };

    if (!errorsOpen) return null;

    return (
        <div className="fixed inset-0 z-50" onClick={handleErrorsClose}>
            <div
                className="absolute bg-white rounded-lg shadow-lg h-[200px] w-[230px] overflow-y-auto"
                style={{
                    top: anchorEl?.getBoundingClientRect().bottom || 0,
                    left: anchorEl?.getBoundingClientRect().right || 0,
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-center pt-4">
                    <span className="material-symbols-outlined text-[35px] text-orange-500">warning</span>
                </div>
                <p className="p-4 pt-2">{firstError}</p>
            </div>
        </div>
    )
}
